/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
// import getConfig from 'next/config'

export default function axiosClient<TResponse = any>(
  baseURL: string | undefined,
  config: AxiosRequestConfig
): AxiosPromise<TResponse> {
  // init axios instance
  const { CancelToken } = axios;
  let source = CancelToken.source();
  // eslint-disable-next-line no-unused-expressions
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  source && source.cancel('Operation canceled due to new request.');

  // save the new request for cancellation
  source = axios.CancelToken.source();
  const instance = axios.create({
    cancelToken: source.token,
    baseURL,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
      // Object: config.url,
      // User: stateData.user,
      // Verb: 'read',
    },
    withCredentials: true,
  });

  // interceptor REQUEST
  instance.interceptors.request.use((reqConfig) => {
    // console.log('==Axios REQUEST==', reqConfig)
    return reqConfig;
  });

  // interceptor RESPONSE
  instance.interceptors.response.use(
    (resp) => {
      // console.log('==Axios SUCCESS RESPONSE==', resp)
      return Promise.resolve(resp);
    },
    (err) => {
      // console.log('==Axios ERROR RESPONSE==', err, err.response)
      return Promise.reject(err);
    }
  );

  // return The Axios Promise
  return instance(config);
}

export function modAxios(baseURL: string | undefined) {
  function _f<TResponse>(url: string, config: AxiosRequestConfig) {
    const config_ = { ...config };
    config_.url = url;

    return axiosClient<TResponse>(baseURL, config_);
  }

  return _f;
}

export const pureAxios = axios.create({});
